import { getGlobalClientId } from '../lib/utils';

const getClientId = () => {
  return getGlobalClientId();
};

export default getClientId;
